import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import type { ReactNode } from 'react';
import { useController } from 'react-hook-form';

type HookFormCheckboxFieldProps = {
  name: string;
  Label?: ReactNode;
};

function HookFormCheckboxField({ name, Label }: HookFormCheckboxFieldProps) {
  const {
    field: { onChange, value: checked, ...restOfFields }
  } = useController({
    name
  });

  return (
    <FormControlLabel
      control={
        <Checkbox checked={checked} onChange={onChange} {...restOfFields} />
      }
      label={Label}
    />
  );
}

export default HookFormCheckboxField;
